import React, { useEffect, useRef, useState } from "react";
import Navbar from "../component/Navbar";
import ProductHeader from "../component/ProductHeader";
import Footer from "../component/Footer";
import {
  ButtonBack,
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import Images from "../assets/Image";
import FileName from "../broucherPdf/filePdf";
import { FaDownload } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import ContactUsFooter from "../component/ContactUsFooter";
const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const imageRef = useRef(null);
  const sectionRef = useRef(null);
  const doubleCardRef = useRef(null);
  const visionMissionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleCard, setIsVisibleCard] = useState(false);
  const [isVisibleDoubleCard, setIsVisibleDoubleCard] = useState(false);
  const [visionMissionCard, setVisionMissionCard] = useState(false);

  const productDetail = [
    {
      productCategory: "Consumables",
      idName: "consumables",
      productDetails: [
        {
          productName: "USP SIMACOLOR FLUIDS",
          productImage: Images?.uspstream14,
          pageNavigate: "/product/uspSimacolorFluids",
          fileName: "SIMACOLOR FLUIDS.pdf",
          downloadFile: FileName?.SIMACOLOR_fluids,
        },
        {
          productName: "USP TTO RIBBONS",
          productImage: Images?.uspstream15,
          pageNavigate: "/product/uspTtoRibbons",
          fileName: "USP TTO Ribbons.pdf",
          downloadFile: FileName?.usp_TTO_Ribbons,
        },
      ],
    },
    {
      productCategory: "CIJ PRINTERS",
      idName: "cij_printer",
      productDetails: [
        {
          productName: "USP JETSTREAM II",
          productImage: Images?.uspstream2,
          pageNavigate: "/product/uspJetStream2",
          fileName: "USP JETSTREAM II.pdf",
          downloadFile: FileName?.usp_JETSTREAM_II,
        },
        {
          productName: "USP A-2120",
          productImage: Images?.uspstream4,
          pageNavigate: "/product/uspA2120",
          fileName: "USP A-2120.pdf",
          downloadFile: FileName?.usp_a2120,
        },
        {
          productName: "USP STREAMLINE 4SP",
          productImage: Images?.productDemo,
          pageNavigate: "/product/uspStreamLine4SP",
          fileName: "STREAMLINE 4SP.pdf",
          downloadFile: FileName?.STREAMLINE_4sp,
        },
        {
          productName: "USP JETSTREAM II (Dual Head)",
          productImage: Images?.uspstream2,
          pageNavigate: "/product/uspJetStreamDualHead",
          fileName: "JETSTREAM II DUAL PRINTHEAD SYSTEM.pdf",
          downloadFile: FileName?.usp_JETSTREAM_II_DUAL_HEAD,
        },
      ],
    },
    {
      productCategory: "TTO PRINTERS",
      idName: "tto_printer",
      productDetails: [
        {
          productName: "USP TTO 03S & 05SS",
          productImage: Images?.UspTto03jPrinter,
          pageNavigate: "/product/uspTto03s05s",
          fileName: "USP TTO 03S & 05S.pdf",
          downloadFile: FileName?.usp_TTO_D03S_D05S,
        },
      ],
    },
    {
      productCategory: "Hi-RESOLUTION PRINTERS",
      idName: "resolution_printer",
      productDetails: [
        {
          productName: "USP COPILOT 128 & 256",
          productImage: Images?.uspstream5,
          pageNavigate: "/product/copilot128-256",
          fileName: "USP COPILOT 128-256.pdf",
          downloadFile: FileName?.usp_COPILOt_128_256,
        },
        {
          productName: "USP COPILOT MAX 400",
          productImage: Images?.uspstream7,
          pageNavigate: "/product/copilotMax400",
          fileName: "USP COPILOT 400.pdf",
          downloadFile: FileName?.usp_COPILOt_400,
        },
        {
          productName: "USP COPILOT MAX 512i",
          productImage: Images?.uspstream8,
          pageNavigate: "/product/copilotMax512iTurbo",
          fileName: "USP CoPilot MAX 512i TURBO.pdf",
          downloadFile: FileName?.usp_CoPilot_MAX_512i_TURBO,
        },
        {
          productName: "USP COPILOT MAX TURBO",
          productImage: Images?.uspstream5,
          pageNavigate: "/product/copilotMaxTurbo",
          fileName: "USP CO PILOT MAX TURBO.pdf",
          downloadFile: FileName?.usp_CO_PILOT_MAX_TURBO,
        },
        {
          productName: "USP COPILOT MAX LT",
          productImage: Images?.uspstream10,
          pageNavigate: "/product/copilotMaxlt",
          fileName: "USP COPILOT MAX LT.pdf",
          downloadFile: FileName?.usp_COPILOT_MAX_LT,
        },
        {
          productName: "USP COPILOT GEMINI",
          productImage: Images?.uspstream7,
          pageNavigate: "/product/copilotGemini",
          fileName: "Co_Pilot_Gemini.pdf",
          downloadFile: FileName?.Co_Pilot_Gemini,
        },
      ],
    },
    {
      productCategory: "LASER CODING SYSTEMS",
      idName: "laser_coding_system",
      productDetails: [
        {
          productName: "USP CO2 LASER",
          productImage: Images?.uspstream18,
          pageNavigate: "/product/uspCo2Laser",
          fileName: "USP CO2 Laser.pdf",
          downloadFile: FileName?.usp_CO2_Laser,
        },
        {
          productName: "USP FIBER LASER",
          productImage: Images?.uspstream17,
          pageNavigate: "/product/uspFiberLaser",
          fileName: "USP FIBER LASER.pdf",
          downloadFile: FileName?.usp_FIBER_LASER,
        },
        {
          productName: "USP UV LASER",
          productImage: Images?.uspstream19,
          pageNavigate: "/product/uspUvLaser",
          fileName: "USP UVLaser.pdf",
          downloadFile: FileName?.usp_UVLaser,
        },
      ],
    },
  ];

  const whyChooseUspCard = [
    {
      cardImg: Images?.homePageChooseCard1,
      cardHeader: "Onsite Services",
      cardData:
        "Timely Preventive Maintenance /Breakdown visits ensure smooth running of production lines and zero loss in productivity.",
    },
    {
      cardImg: Images?.homePageChooseCard2,
      cardHeader: "Technical Support",
      cardData:
        "Trained professionals who can expertly handle such situations will be attending to your calls.",
    },
    {
      cardImg: Images?.homePageChooseCard3,
      cardHeader: "Technical Training",
      cardData:
        "All technical training are conducted by certified professional trainers with Flexible timings for training.",
    },
    {
      cardImg: Images?.homePageChooseCard4,
      cardHeader: "Product Sampling",
      cardData:
        "You can request Product Sampling by calling us on +91 97909 34910 or emailing us at enquiries@usppkg.com",
    },
  ];

  const doubleCardDetails = [
    {
      cardImage: Images?.homeDoubleCard1,
      cardHeader: "Solutions by Industry",
      cardData:
        "As solutions offered by us are need based, apt product recommendation is our key to success. Every customers need varies from industry to industry. For an instance, some companies stress the need of indelible prints, whereas in other cases customers target the equipment that suits their packaging substrate with lower running costs.",
    },
    {
      cardImage: Images?.homeDoubleCard2,
      cardHeader: "Solutions by Application",
      cardData:
        "Depending on the substrate and the product that you want to code and mark, you could probably end up purchasing different printers. Every printer has its own unique set of features that makes it suitable for a certain set of substrates or application.",
    },
    {
      cardImage: Images?.homeDoubleCard3,
      cardHeader: "Services On Offer",
      cardData:
        "You can reach us for any coder requirement such as CIJ, TTOP, Hi-Res, Lasers, Consumables, spares & technical support for our range of products as well as for few reputed brands in the market.",
    },
    {
      cardImage: Images?.homeDoubleCard4,
      cardHeader: "Services On Offer",
      cardData:
        "You can schedule Preventive Maintenance on Annual Contract from our certified experts. This supports maximum uptime and high productivity, in addition to nearly 50% saving on maintenance costs.  Comprehensive maintenance contract too, is offered on our selected product range.",
    },
    {
      cardImage: Images?.homeDoubleCard5,
      cardHeader: "News & Press Release",
      cardData:
        "In today’s world of myriad products that sweep a spectrum of applications in Food, Pharma, Cosmetics, etc., the packaging serves as a key factor in successful marketing, be it in brand mileage or, more importantly, for security and hygiene.",
    },
    {
      cardImage: Images?.homeDoubleCard6,
      cardHeader: "Tradeshow Events",
      cardData:
        "Here is where our world class technology meets the decision-makers. Our product range in live display will give the satisfaction while hands on experience at the trade shows.",
    },
  ];
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.7 }, // Trigger when 70% of the image is visible
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
    };
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisibleCard(true);
        }
      },
      { threshold: 0.3 }, // Trigger animation when 30% of the div is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisibleDoubleCard(true);
        }
      },
      { threshold: 0.3 }, // Trigger animation when 30% of the div is visible
    );

    if (doubleCardRef.current) {
      observer.observe(doubleCardRef.current.children[4]);
    }

    return () => {
      if (doubleCardRef.current) {
        observer.unobserve(doubleCardRef.current.children[4]);
      }
    };
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisionMissionCard(true);
          observer.disconnect(); // Run only once
        }
      },
      { threshold: 0.6 },
    );

    if (visionMissionRef.current) observer.observe(visionMissionRef.current);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.replace("#", "");
      const el = document.getElementById(elementId);
      if (el) {
        // Use native scrollIntoView for better compatibility + smooth behavior
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else {
      // If no hash, scroll to top (optional)
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <div className="homeContainer">
        <div className="infinite-scroll">
          <div className="scroll-content">
            {/* BLOCK 1 - CII FOOD PRO 2026 */}
            <div className="block">
              <div className="event-text">
                <a href={Images?.slider4}>CII FOOD PRO 2026 – JULY, 7-9, 2026</a>
              </div>
              <div
                style={{ width: "100%", height: "75vh", objectFit: "contain" }}
              >
                <img
                  src={Images?.upcoming_event_july}
                  alt="CII FOOD PRO 2026"
                  title="CII FOOD PRO 2026 – JULY, 7-9, 2026"
                />
              </div>
            </div>

            {/* BLOCK 2 - PAST EVENTS */}
            <div className="block">
              <div className="event-text">
                <a href={Images?.slider4}>PAST EVENTS</a>
              </div>
              <div
                style={{ width: "100%", height: "75vh", objectFit: "contain" }}
              >
                <img
                  src={Images?.addresstheme}
                  alt="banner"
                  title="PAST EVENT"
                />
              </div>
            </div>

            {/* BLOCK 2 */}
            <div className="block">
              <div className="event-text">
                <a href={Images?.slider4}>
                  FOOD & DRINK PROCESSING EXPO - 02-04_JULY 2025
                </a>
              </div>
              <div
                style={{ width: "100%", height: "75vh", objectFit: "contain" }}
              >
                <img
                  src={Images?.fooddrinkexpo}
                  alt="banner"
                  title="PAST EVENT"
                />
              </div>
            </div>

            {/* BLOCK 3 */}
            <div className="block">
              <div className="event-text">
                <a href={Images?.slider4}>
                  CII Kerala Packaging Conference - 22 AUGUST 2025
                </a>
              </div>
              <div
                style={{ width: "100%", height: "75vh", objectFit: "contain" }}
              >
                <img src={Images?.keralapack} alt="banner" title="PAST EVENT" />
              </div>
            </div>
            <div className="block">
              <div className="event-text">
                <a href={Images?.slider4}>
                  52nd dairy-industry-conference-and-exhibition - February 12-14
                  2026
                </a>
              </div>
              <div
                style={{ width: "100%", height: "75vh", objectFit: "contain" }}
              >
                <img
                  src={Images?.dairyindustry}
                  alt="banner"
                  title="PAST EVENT"
                />
              </div>
            </div>
          </div>
        </div>

        {/* <div>
          <CarouselProvider
            naturalSlideWidth={100}
            naturalSlideHeight={50}
            totalSlides={4}
          >
            <Slider isPlaying={true}>
              
              <Slide index={0}>
                <img src={Images?.slider5} alt="slider1" />
              </Slide>
              <Slide index={1}>
                <img src={Images?.slider1} alt="slider1" />
              </Slide>
              <Slide index={2}>
                {" "}
                <img src={Images?.slider2} alt="slider2" />
              </Slide>
              <Slide index={3}>
                {" "}
                <img src={Images?.slider3} alt="slider3" />
              </Slide>
            </Slider>
          </CarouselProvider>
        </div> */}

        <div className="companyNameContainer py-5">
          <div className="flex flex-col items-center justify-center">
            <div
              className={`companyNameImg ${isVisible ? "show" : ""}`}
              ref={imageRef}
            >
              <img src={Images?.companyNameImg} alt="companyNameImg" />
            </div>
            <div
              className={`companyNameTxt ${isVisible ? "show" : ""}`}
              ref={imageRef}
            >
              <img src={Images?.CompanyNameText} alt="companyNameImg" />
            </div>
          </div>
        </div>

        <div className="knowAsContainer">
          <div className="knowAsTxtContainer">
            <div className="knowAsLeft px-8 py-2">
              <div className="knowAsTxt">Know Us</div>
              <div className="knowAsSubTxt">
                The journey of a thousand miles begins with a single step… Mr.
                Joseph established USP in the year 2001, with the objective of
                introducing technology‐driven solutions in the
                packaging industry. Much like the packaging industry that has
                evolved with newer printers that offer better quality and
                cost‐effectiveness, USP has grown steadily over the years to
                become a market leader today.
              </div>
              <div className="knowAsSubTxt">
                Our team continually scans the markets for printers, consumables
                and other packaging solutions to identify the best products that
                can be made available and be utilised to fulfil the requirements
                of our customers, so that use the latest technological trends
                and methodologies can be deployed to leverage desired results,
                to the complete satisfaction of our customers.
              </div>
              <div className="knowAsSubTxt">
                The resilience of team USP in its dauntless approach to
                challenges and in overcoming many an obstacle has piloted the
                company and brand to the heights of success no wonder, then, we
                have become the choice packaging solutions partner for some of
                the top global brands in the market.
              </div>
              <div className="knowAsSubTxt">
                Our endeavours and work spirit stems from core business values,
                honesty, integrity and a nocompromise attitude in ensuring the
                very best for the customer precisely, the result of performance
                meeting or exceeding expectation!
              </div>
            </div>
            <div className="knowAsRight">
              <img
                className="knowAsImg"
                src={Images?.knowAsImg}
                alt="knowAsImg"
              />
              <div>
                <div
                  className="knowAsBtn"
                  onClick={() => {
                    window.location.href = "/knowUs";
                  }}
                >
                  Know Us
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cardContainer">
          <div
            className={`card ${visionMissionCard ? "animate" : ""}`}
            ref={visionMissionRef}
          >
            <div className="cardHeaderImg">
              <img
                className="cardImg"
                src={Images?.homePageVisionCard}
                alt="homePageVisionCard"
              />
              <div className="imgBlurOverlay"></div>
              <div className="sharpOverlay leftPanel"></div>
              <div className="sharpOverlay rightPanel"></div>
            </div>
            <div className="cardTxt">
              <div className="cardTxtHeader">VISION</div>
              <div className="cardTxtData">
                To be recognised as a world leader in the industry of packaging
                solutions by providing high quality products and services to all
                our clients in a timely manner. We envision USP as a brand that
                every industry recognises and desire to partner with for their
                company's packaging solutions.
              </div>
            </div>
          </div>
          <div className={`card ${visionMissionCard ? "animate" : ""}`}>
            <div className="cardHeaderImg">
              <img
                className="cardImg"
                src={Images?.homePageMissionCard}
                alt="homePageVisionCard"
              />
              <div className="imgBlurOverlay"></div>
              <div className="sharpOverlay leftPanel"></div>
              <div className="sharpOverlay rightPanel"></div>
            </div>
            <div className="cardTxt">
              <div className="cardTxtHeader">MISSION</div>
              <div className="cardTxtData">
                To identify the latest technological trends and methodologies
                which are being utilised in the packaging industry and to
                provide our clients with such solutions that keep them ahead in
                their industry. In doing so, we aim at enhancing the overall
                productivity and success of our clients which will fuel our own
                desire to achieve.
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <div className="ourProductContainer">
            <div className="ourProductContainerHeader">OUR PRODUCT RANGE</div>
            <div className="productListContainer">
              {productDetail?.map((product, index) => (
                <div
                  key={index}
                  id={product?.idName}
                  className="scroll-section"
                >
                  <div className="productNameHeader">
                    {product?.productCategory}
                  </div>
                  <div className="productDetailsMainContainer">
                    {product?.productDetails?.map((productDetail, index) => (
                      <div key={index} className="productDetailsContainer">
                        {/* Black overlay container */}
                        <div className="overlayContainer">
                          <div className="productImageContainer">
                            <img
                              className="w-[100%]"
                              src={productDetail.productImage}
                              alt=""
                            />
                          </div>
                          {/* Buttons */}
                          <div className="imageButtons">
                            {/* <button
                              onClick={() => {
                                window.location.href =
                                  productDetail?.pageNavigate;
                              }}
                              className="viewMoreBtn"
                            >
                              View More
                            </button> */}
                            <button
                              onClick={() =>
                                navigate(productDetail?.pageNavigate)
                              }
                              className="viewMoreBtn"
                            >
                              View More
                            </button>

                            <a
                              href={productDetail.downloadFile}
                              download={productDetail.fileName}
                            >
                              <button className="downloadBtn">
                                <FaDownload />
                              </button>
                            </a>
                          </div>
                          <div className="productName">
                            {productDetail.productName}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="chooseUspContainer">
          <div className="ourProductContainerHeader">Why Choose USP?</div>
          <div className="chooseUspData">
            In today’s world of myriad products that sweep a spectrum of
            applications ‐ food, cosmetics, pharmaceutical and the like ‐
            packaging serves as the key factor to successful marketing, be it in
            brand mileage or, more importantly, for security and hygiene. The
            present‐day industry mandates clear, indelible marking of crucial
            parameters on the packaging of any product or, on the product
            itself, as the application may demand. We at USP see this as a great
            platform to reach out to every single person who lifts a packaged
            product from the shelf with a desire to purchase it. So, over a
            period of nearly two decades, we have come to know and understand by
            carefully listening to what the customer needs… and, by virtue of
            this, USP has evolved from being a mere product reseller in the
            early years, to becoming a market leader in the coding and marking
            industry segment, by providing comprehensive one‐stop solutions for
            a host of industry applications and, for every single need of the
            customer.
          </div>
          <div ref={sectionRef} className="chooseUspCardContainer">
            {whyChooseUspCard.map((card, index) => (
              <div
                key={index}
                className={`chooseUspCard ${isVisibleCard ? "active" : ""}`}
              >
                <div className="chooseUspCardImg flex justify-center">
                  <img className="w-[65px]" src={card?.cardImg} alt="Card" />
                </div>
                <div className="productNameHeader">{card?.cardHeader}</div>
                <div className="chooseUspCardData">{card?.cardData}</div>
              </div>
            ))}
          </div>

          <div ref={doubleCardRef} className="chooseUspDoubleCardContainer">
            {doubleCardDetails?.map((card, index) => {
              return (
                <div
                  key={index}
                  className={`doubleCardInnerContainer ${isVisibleDoubleCard ? "active" : ""
                    }`}
                >
                  <div className="upperDoubleCard">
                    <img
                      className="h-[250px]"
                      src={card?.cardImage}
                      alt="homeDoubleCard1"
                    />
                  </div>
                  <div className="lowerDoubleCard">
                    <div className="doubleHeader">{card?.cardHeader}</div>
                    <div style={{ textAlign: "justify" }}>{card?.cardData}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* <ContactUsFooter /> */}
      <Footer />
    </>
  );
};

export default Home;
